'use client';
module.exports = require('../dist/components/Text/Text');
